import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Loader, Card} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import Header from '../common/Header';
import CommonTable from '../common/Table';
import {generateClientColumns} from '../../constants';
import './styles.scss';
import UploadFlInventoryFiles from './../common/uploadFiles';
import {UserGroup} from '../../../floatingInventory/constants/userGroup';
class ClientManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'filteredRows': 0,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.updateTable !== this.props.updateTable) {
      this.props.fetchClientManagementList(this.props.dealerId);
    }
  }

  componentDidMount() {
    if (
      !hasAccessPermission(this.props.permissions, resources.ClientManagement, scopes.See)
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    if (this.props.isUserTde) {
      this.props.setCurrentFlUserGroup(UserGroup.tdeUser);
    } else if (
      hasAccessPermission(this.props.permissions, resources.ClientManagement, scopes.Edit) &&
      hasAccessPermission(this.props.permissions, resources.ClientManagement, scopes.See) &&
      hasAccessPermission(this.props.permissions, resources.ClientManagement, scopes.Create)
    ) {
      this.props.setCurrentFlUserGroup(UserGroup.coachDealer);
    } else {
      this.props.setCurrentFlUserGroup(UserGroup.adviserDealer);
    }

    this.props.fetchDealers('float');
    this.props.fetchClientManagementList(this.props.dealerId);
    this.props.fetchContributorTypes();
    this.props.fetchProvinceTypes();
    this.props.fetchCitiesCodes();
    this.props.fetchClientTypes();
    this.props.fetchExemptionManagementList();
  }

  handleChange = (field, value) => {
    this.setState({
      [field]: value,
    });
  }

  renderLoader() {
    return (
      <Table striped className='toyota-grid'>
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan='100%'>
              <Loader active inline='centered' content='Ejecutando' />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }

  render() {
    const {filteredRows} = this.state;
    const {isUserTde, loadingList, list} = this.props;
    const isAvailable = ([UserGroup.coachDealer, UserGroup.tdeUser].includes(this.props.currentFlUserGroup));
    return (
      <div className="client-admin-container">
        <Header
          title="Administración de Clientes Exonerados"
          name="cliente"
          filteredRows={filteredRows}
          detail=""
          saveChanges=""
          contentType='client'
        />
        <Card raised fluid className="processed-warranty-table">
          {loadingList ? (
            this.renderLoader()
          ) : (
            <CommonTable
              filteredRows={filteredRows}
              list={list}
              columnsTable={generateClientColumns(
                {isAvailable, isUserTde},
              )}
              handleChange={this.handleChange}
            />
          )}
        </Card>
        <UploadFlInventoryFiles />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'list': state.clientManagment.list,
    'loadingList': state.clientManagment.loadingList,
    'exemptionList': state.exemptionManagment.list,
    'dealerId': state.session.dealerId,
    'currentFlUserGroup': state.floatingInventory.currentFlUserGroup,
    'isUserTde': state.session.isUserFromTDE,
    'updateTable': state.clientManagementForm.updateTable,
  };
};

const {
  withRouter,
  fetchTwcList,
  clearTwcList,
  fetchFileData,
  fetchWarrantySequences,
  fetchWarrantyStatus,
  addWarrantyChecked,
  removeWarrantyChecked,
  fetchClientManagementList,
  fetchContributorTypes,
  fetchProvinceTypes,
  fetchCitiesCodes,
  fetchClientTypes,
  fetchExemptionManagementList,
  fetchDealers,
  navigateTo,
  setCurrentFlUserGroup,
} = Actions;

const mapDispatchToProps = {
  fetchTwcList,
  fetchFileData,
  clearTwcList,
  fetchWarrantySequences,
  fetchWarrantyStatus,
  addWarrantyChecked,
  removeWarrantyChecked,
  fetchClientManagementList,
  fetchContributorTypes,
  fetchProvinceTypes,
  fetchCitiesCodes,
  fetchClientTypes,
  fetchExemptionManagementList,
  fetchDealers,
  navigateTo,
  setCurrentFlUserGroup,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ClientManagement)
);
